<template>
  <b-form-checkbox
    v-bind:checked="value"
    class="custom-check"
    v-on:change="onChange"
  />
</template>

<script>
/**
 * ag-grid の cell に BFormCheckbox を描画するレンダラー
 */
export default {
  name: 'AppBFormCheckboxCellRenderer',
  data: function () {
    return {
      /**
       * 選択状態
       * @type {boolean}
       */
      value: false,
    }
  },
  computed: {
    /**
     * gridApi
     * @type {GridApi}
     */
    gridApi: function () {
      return this.params.api
    },
  },
  created: function () {
    // 初期状態を反映
    this.onSelectionChange()
  },
  mounted: function () {
    this.gridApi.addEventListener('selectionChanged', this.onSelectionChange)
  },
  beforeDestroy: function () {
    this.gridApi.removeEventListener('selectionChanged', this.onSelectionChange)
  },
  methods: {
    /**
     * チェックボックスの change イベントコールバック
     */
    onChange(v) {
      this.params.node.setSelected(v)
    },
    /**
     * ag-grid の selectionChanged イベントコールバック
     */
    onSelectionChange() {
      this.value = this.params.node.isSelected()
    },
  },
}
</script>

<style lang="scss" scoped>
.custom-check {
  padding-left: 1rem;
  min-height: 1rem;
  height: 1rem;

  ::v-deep .custom-control-input {
    height: 1rem;
  }

  ::v-deep .custom-control-label {
    &::before {
      top: 0;
      left: -1rem;
    }
    &::after {
      top: 0;
      left: -1rem;
    }
  }
}
</style>
